import React, { Fragment, useEffect, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Input, FormText, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ModalContext from '../../../../fgs/context/ModalContext';
import AsyncSelect from 'react-select/async';
import { newFolderForm } from "../../../forms";

import { getUserNames, getUserFolders, createDirectory } from "../../../../services/api";

const NewDirectoryModalContent = (props) => {
  const { fetchDocuments } = props;
  const [form, setForm] = useState(newFolderForm);
  const [defaultUserOptions, setDefaultUserOptions] = useState([]);
  const [defaultDirOptions, setDefaultDirOptions] = useState([]);
  const { toggle } = useContext(ModalContext);

  const onChange = (name, selected) => {
    const selectedValue = selected ? selected.value : '';
    const newForm = Object.assign({}, form);
    newForm[name] = selectedValue;

    if (name === 'userId') {
      newForm.parentId = null;
      getUserFolders(selectedValue).then((response) => setData(response, setDefaultDirOptions));
    }

    setForm(newForm);
  };

  const onInputChange = (e) => {
    const newForm = Object.assign({}, form);
    newForm.dirName = e.target.value;

    setForm(newForm);
  };

  const setData = (response, callback) => {
    if (response.data) {
      const names = response.data.map(data => {
        return {
          value: data.id,
          label: data.name
        };
      });
      callback(names);
    }
  };

  const fetchUserNames = async (inputValue, callback) => {
    await getUserNames(inputValue).then((response) => setData(response, callback));
  };

  const fetchUserFolders = async (inputValue, callback) => {
    if (!form.userId) return;

    await getUserFolders(form.userId, inputValue).then((response) => setData(response, callback));
  };

  useEffect(() => {
    fetchUserNames(null, setDefaultUserOptions);
  }, []);

  const createFolder = () => {
    createDirectory(form).then(() => {
      toggle();
      fetchDocuments();
    });
  };

  const onEnter = (e) => {
    if (e.key === 'Enter') createFolder();
  };

  return (
    <Fragment>
      <ModalHeader>
        Nova Pasta
      </ModalHeader>
      <ModalBody onKeyDown={onEnter}>
        <div>
          <FormGroup>
            <AsyncSelect
              placeholder="John Doe"
              isClearable={true}
              cacheOptions
              loadOptions={fetchUserNames}
              defaultOptions={defaultUserOptions}
              value={defaultUserOptions.find(opt => opt.value === form.userId)}
              onChange={(selected) => onChange('userId', selected)} />
          </FormGroup>
          <FormGroup>
            <AsyncSelect
              placeholder="imagens"
              isClearable={true}
              cacheOptions={false}
              loadOptions={fetchUserFolders}
              defaultOptions={defaultDirOptions}
              value={defaultDirOptions.find(opt => opt.value === form.parentId)}
              onChange={(selected) => onChange('parentId', selected)} />
          </FormGroup>
          <FormGroup>
            <Input
              type="text"
              placeholder='Nome da pasta. ex: minha_pasta1'
              value={form.dirName}
              onChange={onInputChange} />
            <FormText className="text-muted">
              Evite nomes com caracteres especiais <span>&quot;ex: /~[\&quot;</span>
            </FormText>
          </FormGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={!form.dirName || !form.userId}
          color="success"
          onClick={createFolder}>
          Salvar
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
      </ModalFooter>
    </Fragment>
  );
};

NewDirectoryModalContent.propTypes = {
  fetchDocuments: PropTypes.func.isRequired
};

export default NewDirectoryModalContent;
